// src/pages/About.js
export default function About() {
  return (
    <div style={{ padding: 32 }}>
      <h1>About Us</h1>
      <p>
        Welcome to the University Admission Center (UAC)!<br />
        We help students apply to universities and colleges with ease.
      </p>
    </div>
  );
}
